import React, { useEffect, useState, useContext } from "react";

import LocalizationContext from "../LocalizationContext";
import CustomizationContext from "../CustomizationContext";

import * as SystemConsts from "../Shared/Constants";
import isEmail from "validator/lib/isEmail";
import LoadingInfynito from "../Shared/LoadingInfynito";

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Stack } from "@mui/material";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Parser } from 'html-to-react'


export const RequestFrom = (props) => {
    const localizationCtx = useContext(LocalizationContext);
    const urlPolicy = "https://www.ferretti-yachts.com/" + localizationCtx.localizationData.cultureCode + "/Policy";

    const [isSending, setIsSending] = useState(false);
    const [isSent, setIsSent] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [withCustomization, setWithCustomization] = useState(false);
    const customizationCtx = useContext(CustomizationContext);

    const [crmData, setCrmData] = useState(null);
    const [zonesList, setZonesList] = useState([]);

    const [interactionData, setInteractionData] = useState({
        modelCode: props.modelCode,
        idCustomization: "",
        city: "",
        address: "",
        zipCode: "",
        countryId: "",
        provinceId: SystemConsts.emptyGuid,
        emailAddress: "",
        name: "",
        surname: "",
        phoneNumber: "",
        flagGdprMarketing: false,
        flagGdprProfiling: false,
        flagGdprCompliance: false,
        flagGdprFraud: false,
        infoRequest: "",
        boatOwner: false,
        boatOwnerShipyard: "",
        boatOwnerModel: ""
    });


    const [isValid, setIsValid] = useState({
        countryId: true,
        emailAddress: true,
        name: true,
        surname: true,
        flagGdprCompliance: true,
        infoRequest: true
    });

    const [isFormatValid, setIsFormatValid] = useState({
        emailAddress: true,
    });

    const handleChangeInteractionData = (event) => {
        const { id, value } = event.target;

        if (id) {

            if ((id === "flagGdprMarketing") || (id === "flagGdprProfiling") || (id === "flagGdprCompliance") || (id === "flagGdprFraud") || (id === "boatOwner")) {
                setInteractionData({ ...interactionData, [id]: event.target.checked });
            } else {
                setInteractionData({ ...interactionData, [id]: value });
            }

            if (id === "emailAddress" && value) {
                setIsFormatValid({ ...isFormatValid, [id]: isEmail(value) });
            }

            if ((id === "emailAddress") || (id === "name") || (id === "surname") || (id === "infoRequest")) {
                setIsValid({ ...isValid, [id]: (value !== "") });
            }

            if (id === "countryId") {
                setIsValid({ ...isValid, [id]: (value !== SystemConsts.emptyGuid) });
            }

            if (id === "flagGdprCompliance") {
                setIsValid({ ...isValid, [id]: event.target.checked });
            }
        }
    };

    const handleChangeCountry = (event) => {
        let selectedCountry = event.target.value;
        setInteractionData({ ...interactionData, countryId: selectedCountry });
        if (selectedCountry) {
            setIsValid({ ...isValid, countryId: true });
        }
        loadZones(selectedCountry);
    }

    const loadZones = (country) => {
        let zones = crmData.provincesData.filter(prov => prov.idCountry === country);
        setZonesList(zones);
    }

    const handleChangeProvince = (event) => {
        let selectedProvince = event.target.value;
        if (selectedProvince) {
            setInteractionData({ ...interactionData, provinceId: selectedProvince });
        } else {
            setInteractionData({ ...interactionData, provinceId: SystemConsts.emptyGuid });
        }
    }

    const isValidForm = (postData) => {

        // double check
        const isValidCountryId = (!!postData.countryId && postData.countryId !== SystemConsts.emptyGuid);
        const isValidEmailAddress = (!!postData.emailAddress && isEmail(postData.emailAddress) && postData.emailAddress !== "");
        const isValidName = (!!postData.name && postData.name !== "");
        const isValidSurname = (!!postData.surname && postData.surname !== "");
        const isValidInfoRequest = (!!postData.infoRequest && postData.infoRequest !== "");
        const isValidFlagGdprCompliance = (!!postData.flagGdprCompliance && postData.flagGdprCompliance);

        setIsValid({ ...isValid, countryId: isValidCountryId, emailAddress: isValidEmailAddress, name: isValidName, surname: isValidSurname, infoRequest: isValidInfoRequest, flagGdprCompliance: isValidFlagGdprCompliance });

        const formIsValid = (isValidCountryId && isValidEmailAddress && isValidName && isValidSurname &&
            isValidInfoRequest && isValidFlagGdprCompliance);

        return formIsValid;

    };

    const handleSendClick = async () => {
        if (isValidForm(interactionData)) {
            setIsSending(true);

            if (withCustomization) {
                interactionData.idCustomization = customizationCtx.customizationData.idCustomization;
            } else {
                interactionData.idCustomization = '';
            }
            if (!interactionData.provinceId) {
                interactionData.provinceId = SystemConsts.emptyGuid;
            }
            let postUrl = "/api/request/sendinteraction";

            const response = await fetch(postUrl, {
                method: 'POST',
                body: JSON.stringify(interactionData),
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                if (data) {
                    if (withCustomization) {
                        props.updateStepCallBack(3);
                    } else {
                        setIsSending(false);
                        setIsSent(true);
                    }
                }
            } else {
                setIsSending(true);
                const error = await response.text();
                props.feedbackCallback("error", error, true);
            }
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'white',
        boxShadow: 24,
        p: 4,
    };

    const handleClose = () => setIsSending(false);

    const handleCloseSent = () => {
        window.location.href = window.location;
    };


    const loadCrmData = async () => {
        setIsLoading(true);

        const responseCat = await fetch("/api/request/getcatalogue");

        if (responseCat.ok) {
            const data = await responseCat.json();
            if (data) {
                setCrmData(data);
            } else {
                props.feedbackCallback("error", "Error loading external data", true);
            }

        } else {
            const error = await responseCat.text();
            console.log(error);
            props.feedbackCallback("error", error, true);
        }

        setIsLoading(false);
    }

    useEffect(() => {
        setWithCustomization(props.withCustomization);
        loadCrmData();
    }, []);


    return (
        <>
            {isLoading &&
                <div className="py-5 bkg-white">
                    <LoadingInfynito message={localizationCtx.localizationData.loadingWait} />
                </div>
            }
            {
                !isLoading && <>

                    <div className="container bkg-light-gray p-5">
                        <div className="row d-flex justify-content-center">
                            <div className="col-12 col-lg-10">
                                <Grid item container xs={12} spacing={2}>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            size="small"
                                            id="name"
                                            label={localizationCtx.localizationData.formName}
                                            variant="filled"
                                            error={!isValid.name}
                                            helperText={!isValid.name ? localizationCtx.localizationData.formAlertMandatoryField : ""}
                                            value={interactionData.name || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="surname"
                                            label={localizationCtx.localizationData.formSurname}
                                            variant="filled"
                                            size="small"
                                            error={!isValid.surname}
                                            helperText={!isValid.surname ? localizationCtx.localizationData.formAlertMandatoryField : ""}
                                            value={interactionData.surname || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={4}>
                                        <TextField
                                            fullWidth
                                            id="address"
                                            label={localizationCtx.localizationData.formAddress}
                                            variant="filled"
                                            size="small"
                                            value={interactionData.address || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={8} md={4}>
                                        <TextField
                                            fullWidth
                                            id="city"
                                            label={localizationCtx.localizationData.formCity}
                                            variant="filled"
                                            size="small"
                                            value={interactionData.city || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={4} md={4}>
                                        <TextField
                                            fullWidth
                                            id="zipCode"
                                            label={localizationCtx.localizationData.formZipCode}
                                            variant="filled"
                                            size="small"
                                            value={interactionData.zipCode || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth error={!isValid.countryId}>
                                            <InputLabel>{localizationCtx.localizationData.formCountry}</InputLabel>
                                            <Select
                                                labelId="country-label"
                                                id="countryId"
                                                value={interactionData.countryId}
                                                label={localizationCtx.localizationData.formCountry}
                                                onChange={handleChangeCountry}
                                            >

                                                {crmData.countriesData.map((country) => {
                                                    return (
                                                        <MenuItem key={country.idCountry} value={country.idCountry}>
                                                            {country.countryName}
                                                        </MenuItem>
                                                    );
                                                })}

                                            </Select>
                                            <FormHelperText>{!isValid.countryId ? localizationCtx.localizationData.formAlertMandatoryField : ""}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <InputLabel>{localizationCtx.localizationData.formProvince}</InputLabel>
                                            <Select
                                                labelId="zone-label"
                                                id="provinceId"
                                                value={interactionData.provinceId}
                                                label={localizationCtx.localizationData.formProvince}
                                                onChange={handleChangeProvince}
                                            >

                                                {zonesList.map((prov) => {
                                                    return (
                                                        <MenuItem key={prov.idProvince} value={prov.idProvince}>
                                                            {prov.provinceName}
                                                        </MenuItem>
                                                    );
                                                })}

                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="emailAddress"
                                            label={localizationCtx.localizationData.formEmailAddress}
                                            variant="filled"
                                            size="small"
                                            value={interactionData.emailAddress || ""}
                                            error={!isFormatValid.emailAddress || !isValid.emailAddress}
                                            helperText={(!isFormatValid.emailAddress || !isValid.emailAddress) ? localizationCtx.localizationData.formAlertEmailNotValid : ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <TextField
                                            fullWidth
                                            id="phoneNumber"
                                            label={localizationCtx.localizationData.formPhoneNumber}
                                            variant="filled"
                                            size="small"
                                            value={interactionData.phoneNumber || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TextField
                                            fullWidth
                                            id="infoRequest"
                                            label={localizationCtx.localizationData.formRequest}
                                            variant="filled"
                                            size="small"
                                            multiline={true}
                                            minRows="5"
                                            error={!isValid.infoRequest}
                                            helperText={!isValid.infoRequest ? localizationCtx.localizationData.formAlertMandatoryField : ""}
                                            value={interactionData.infoRequest || ""}
                                            onChange={handleChangeInteractionData}
                                        />
                                    </Grid>
                                </Grid>

                                <div className="row pt-5">
                                    <div className="col-12">
                                        <div className="row pb-3">
                                            <div className="col-5">
                                                <p className="textForm">{localizationCtx.localizationData.formBoatOwner}</p>
                                            </div>
                                            <div className="col-7">
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Typography>{localizationCtx.localizationData.flagNo}</Typography>
                                                    <Switch
                                                        id="boatOwner"
                                                        key="boatOwner"
                                                        name="boatOwner"
                                                        variant="filled"
                                                        size="small"
                                                        checked={interactionData.boatOwner}
                                                        onChange={handleChangeInteractionData}
                                                    />
                                                    <Typography>{localizationCtx.localizationData.flagYes}</Typography>
                                                </Stack>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 col-lg-6 pb-1">
                                                <TextField
                                                    fullWidth
                                                    id="boatOwnerShipyard"
                                                    label={localizationCtx.localizationData.formBoatOwnerShipyard}
                                                    variant="filled"
                                                    size="small"
                                                    value={interactionData.boatOwnerShipyard || ""}
                                                    onChange={handleChangeInteractionData}
                                                    disabled={!interactionData.boatOwner}
                                                />
                                            </div>
                                            <div className="col-12 col-lg-6 pb-1">
                                                <TextField
                                                    fullWidth
                                                    id="boatOwnerModel"
                                                    label={localizationCtx.localizationData.formBoatOwnerModel}
                                                    variant="filled"
                                                    size="small"
                                                    value={interactionData.boatOwnerModel || ""}
                                                    onChange={handleChangeInteractionData}
                                                    disabled={!interactionData.boatOwner}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>



                                <div className="row pt-5">
                                    <div className="col-12">
                                        <div className="row">
                                            <div className="col-5">
                                                <p className="textForm">{localizationCtx.localizationData.formFlagGdprCompliance} <a href={urlPolicy} rel="noreferrer" target="_blank"><span className="textFormLink">{localizationCtx.localizationData.formFlagGdprComplianceLink}</span></a> {localizationCtx.localizationData.formFlagGdprCompliance2}</p>
                                            </div>
                                            <div className="col-7 d-flex align-items-center">
                                                <Stack direction="row" spacing={1} alignItems="center">
                                                    <Typography>{localizationCtx.localizationData.flagNo}</Typography>
                                                    <Switch
                                                        id="flagGdprCompliance"
                                                        key="flagGdprCompliance"
                                                        name="flagGdprCompliance"
                                                        variant="filled"
                                                        size="small"
                                                        checked={interactionData.flagGdprCompliance}
                                                        onChange={handleChangeInteractionData}
                                                    />
                                                    <Typography>{localizationCtx.localizationData.flagYes}</Typography>
                                                    {!isValid.flagGdprCompliance && <p className="errorForm">{localizationCtx.localizationData.formAlertFlagCompliance}</p>}
                                                </Stack>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="row">
                                                    <div className="col-12 py-2">
                                                        <p className="textFormLight">{localizationCtx.localizationData.formCookies}</p>
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="textForm pt-2">{localizationCtx.localizationData.formFlagGdprMarketing}</p>
                                                    </div>
                                                    <div className="col-4 d-flex align-items-center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagNo}</Typography>
                                                            <Switch
                                                                id="flagGdprMarketing"
                                                                key="flagGdprMarketing"
                                                                name="flagGdprMarketing"
                                                                variant="filled"
                                                                size="small"
                                                                checked={interactionData.flagGdprMarketing}
                                                                onChange={handleChangeInteractionData}
                                                            />
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagYes}</Typography>
                                                        </Stack>
                                                    </div>
                                                    <div className="col-8">
                                                        <p className="textForm pt-2">{localizationCtx.localizationData.formFlagGdprFraud}</p>
                                                    </div>
                                                    <div className="col-4 d-flex align-items-center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagNo}</Typography>
                                                            <Switch
                                                                id="flagGdprFraud"
                                                                key="flagGdprFraud"
                                                                name="flagGdprFraud"
                                                                variant="filled"
                                                                size="small"
                                                                checked={interactionData.flagGdprFraud}
                                                                onChange={handleChangeInteractionData}
                                                            />
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagYes}</Typography>
                                                        </Stack>
                                                    </div>

                                                    <div className="col-8">
                                                        <p className="textForm pt-2">{localizationCtx.localizationData.formFlagGdprProfiling}</p>
                                                    </div>
                                                    <div className="col-4 d-flex align-items-centerd-flex align-items-center">
                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagNo}</Typography>
                                                            <Switch
                                                                id="flagGdprProfiling"
                                                                key="flagGdprProfiling"
                                                                name="flagGdprProfiling"
                                                                variant="filled"
                                                                size="small"
                                                                checked={interactionData.flagGdprProfiling}
                                                                onChange={handleChangeInteractionData}
                                                            />
                                                            <Typography className="textForm">{localizationCtx.localizationData.flagYes}</Typography>
                                                        </Stack>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-12 text-center">
                                                        <a className="flat-gray-button text-uppercase button-infynito-notactive mt-5" onClick={handleSendClick}>
                                                            {withCustomization === true ? Parser().parse(localizationCtx.localizationData.buttonSend) : Parser().parse(localizationCtx.localizationData.buttonSendNoConfiguration)}
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <Modal
                        open={isSending}
                        onClose={handleClose}
                    >

                        <Box sx={style}>
                            <LoadingInfynito message={withCustomization === true ? localizationCtx.localizationData.loadingSend : localizationCtx.localizationData.loadingSendRequest} />
                        </Box>

                    </Modal>

                    <Modal
                        open={isSent}
                        onClose={handleCloseSent}
                    >

                        <Card sx={style}>
                            <CardHeader
                                action={
                                    <IconButton>
                                    <CloseIcon onClick={handleCloseSent}>
                                        </CloseIcon>
                                    </IconButton>
                                }
                                title={localizationCtx.localizationData.requestSent}
                            />
                            <CardContent >
                                <Typography>
                                    {Parser().parse(localizationCtx.localizationData.requestSentMessage)}
                                </Typography>
                            </CardContent>
                        </Card>

                    </Modal>

                </>
            };
        </>
    );

};

export default RequestFrom;